import { createContext } from 'react'

export const GameAnimationsContext = createContext(null)